export default {
  // 快捷键

  // 角色对应的菜单
  roles: [{
      appId: "standard",
      role: "sys_admin",
      menus: [
        {
          name: "首页",
          path: "/home"
        },
        {
          name: "审核记录",
          path: "/invcheck"
        },
        {
          name: "附件",
          path: "/attachment"
        },
        {
          name: "发票",
          path: "/invoice"
        },
        {
          name: "批量导出管理",
          path: "/collect/paper/download"
        },
        {
          name: "风险",
          path: "/risk",
        },
        {
          name: "档案",
          path: "/archive/paperStat"
        },
        {
          name: "销项发票",
          path: "/salesInvoice"
        },    
        {
          name: "管理",
          menus: [
            {name: "机构", path: "orgs"},
            {name: "机构帐户", path: "orgfin"},
            {name: "充值管理", path: "rechargeAdmin"},
          ]
        },
        {
          name: "我的企业",
          path: "/tcs/ent"
        },
      ]
    },
    {
      appId: "standard",
      role: "org_admin",
      menus: [
        {
          name: "首页",
          path: "/home"
        },
        {
          name: "审核记录",
          path: "/invcheck"
        },
        {
          name: "发票",
          path: "/invoice"
        },
        {
          name: "风险",
          path: "/risk"
        },
        {
          name: "档案",
          path: "/archive/paperStat"
        },
        {
          name: "扫码入账",
          path: "/scanacc"
        },
        {
          name: "销项发票",
          path: "/salesInvoice"
        },
        {
          name: "批量导出管理",
          path: "/collect/paper/download"
        },

        {
          name: "设置",
          path: "/settings"
        }

      ]
    },
    {
      appId: "standard",
      role: "org_fin",
      menus: [
        {
          name: "首页",
          path: "/home"
        },
        {
          name: "审核记录",
          path: "/invcheck"
        },
        {
          name: "发票",
          path: "/invoice"
        },
        {
          name: "风险",
          path: "/risk"
        },
        {
          name: "档案",
          path: "/archive/paperStat"
        },
        {
          name: "扫码入账",
          path: "/scanacc"
        },
        {
          name: "销项发票",
          path: "/salesInvoice"
        },
        {
          name: "批量导出管理",
          path: "/collect/paper/download"
        },

      

      ]
    },
    {
      appId: "maersk",
      role: "org_admin",
      menus: [
        {
          name: "进项发票",
          path: "/collect/invoice"
        },
        {
          name: "批量导出管理",
          path: "/collect/paper/download"
        },
        {
          name: "设置",
          path: "/settings"
        }

      ]
    },
    {
      appId: "maersk",
      role: "org_fin",
      menus: [
        {
          name: "进项发票",
          path: "/collect/invoice"
        },
        {
          name: "批量导出管理",
          path: "/collect/paper/download"
        },

      ]
    },

    {
      appId: "tcs",
      role: "tcs_ent",
      menus: [
       

        {
          name: "数据汇总上报",
          path: "/tcs/upload-task"
        },

        {
          name: "税负预警",
          path: "/tcs/ent-tax"
        },
      ]
    },
    {
      appId: "tcs",
      role: "tcs_jgdw",
      menus: [
       

        {
          name: "我的企业",
          path: "/tcs/ent"
        },

        {
          name: "需求提报",
          path: "/tcs/ent-req"
        },
      ]
    }


      

  ]
}